import React, { Component } from 'react';
import '../../css/modal.scss';
import CloseIcon from '../../img/body/close.png';
import Const from '../../const';
import image from '../../res/image';

class GuideModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { isOpen, close } = this.props;
    const skinType = Const.skinType.toUpperCase();
    return (
      <React.Fragment>
        {isOpen ? (
          <React.Fragment>
            <div className="Modal-overlay" onClick={close} />
            <div className="Modal">
              <div className="guide-title">과적 및 배송가이드</div>
              <div className="guide-image" onClick={close}>
                <img style={{ display: 'inline' }} src={image.closeIcon} alt="" />
              </div>
              <div className="guide-content">
                <div>
                  <div className={skinType === "GOGOIT" ? "gogoit-bullet-dots" : "bullet-dots"} />
                  <div className="guide-content-text">배송가이드</div>
                </div>
                <div>
                  <div className="dots" />
                  <div className="guide-content-text2">
                    고객부재/ 연락두절 : MCC로 연락, 처리방법 확인
                  </div>
                </div>
                <div>
                  <div className="dots" />
                  <div className="guide-content-text3">
                    재이동 : 이동 전 MCC로 연락, 상점 승인 후 진행
                  </div>
                </div>
                <div>
                  <div className="dots" />
                  <div className="guide-content-text4">반납 : 0.5 건 추가</div>
                </div>
                <div>
                  <div className="dots" />
                  <div className="guide-content-text5">
                    배상 : 상품가액의 50%
                  </div>
                </div>
                <div>
                  <div className="guide-content-text6">
                    ※ 고객 과실은 배송신청 주체인 상점주의 과실로 간주됩니다.
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : null}
      </React.Fragment>
    );
  }
}

export default GuideModal;
